export default __webpack_public_path__ + "static/media/hexoscope-logo-rectangle-white.8bfc3d07.svg";